// extracted by mini-css-extract-plugin
export default {"list":"tab_list__kOJb+","tab":"tab_tab__xdUZL"};